import { createAction } from '@reduxjs/toolkit';

export const fetchIssuersInit = createAction('[Issuers] Fetch Issuers Init');
export const fetchIssuersSuccess = createAction(
  '[Issuers] Fetch Issuers Success'
);
export const fetchIssuersFail = createAction('[Issuers] Fetch Issuers Fail');
